import { render, staticRenderFns } from "./CancelFolderDialog.vue?vue&type=template&id=3210fe7e&scoped=true&"
import script from "./CancelFolderDialog.vue?vue&type=script&lang=js&"
export * from "./CancelFolderDialog.vue?vue&type=script&lang=js&"
import style0 from "./CancelFolderDialog.vue?vue&type=style&index=0&id=3210fe7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3210fe7e",
  null
  
)

export default component.exports